<template>
  <el-col :span="24">
    <el-col :span="24" >
      <el-col :span="10" style="text-align: center;margin-top: 20px;margin-bottom: 30px;">
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        autosize
        v-model="err_data">
      </el-input>
      </el-col>
      <el-col :span="8" style="text-align: center;margin-top: 60px;margin-bottom: 30px;">
         <el-link href="https://aegisgameupdata.oss-cn-beijing.aliyuncs.com/%E7%89%88%E6%9C%AC%E6%A0%A1%E9%AA%8C%EF%BC%88%E5%AE%89%E8%A3%85%E5%90%8E%E5%BC%80%E6%9C%BA%E8%87%AA%E5%90%AF%EF%BC%89.zip" type="primary" target="_blank">对应设备电脑桌面没有版本检测工具点击下载</el-link>
        <el-link href="https://doc.weixin.qq.com/doc/w3_ADMALgZsABkp62U3l4JQzWRtU8LW5?scode=ADYAvAfWAA0Cskj4UuADMALgZsABk" type="primary" target="_blank">如何安装/手动运行版本检测工具请点击查看</el-link>
      </el-input>
      </el-col>
      <el-col :span="6" style="text-align: center;margin-top: 50px;margin-bottom: 20px;">
        <el-button type="danger" @click="get_vesion"  :loading="loading_status">刷新</el-button>
      </el-col>
    </el-col>
    <el-table :data="
      tableData.filter(
        (data) =>
          !search || data.name.toLowerCase().includes(search.toLowerCase())
      )
    "
    border
     style="width: 100%">
      <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
      <el-table-column label="厅" prop="hall_type"> </el-table-column>
      <el-table-column label="设备" prop="bag_name" ></el-table-column>
      <el-table-column label="游戏名称" prop="game_name" ></el-table-column>
      <el-table-column label="正常游戏版本范围" prop="g_version" ></el-table-column>
      <el-table-column label="本门店游戏版本" prop="version_local" ></el-table-column>
      <el-table-column label="问题结论" prop="describe" ></el-table-column>
      <el-table-column align="left" label="信息操作" width="250">
<!--        <template slot-scope="scope">
          <el-button style="margin: 0 auto;margin-right: 10px;margin-bottom: 10px;"  type="warning" @click="modify_information(scope.row)">修改信息</el-button>
          <el-popconfirm
            title="确认删除此条排场？"
            @confirm="delete_information(scope.row)"
          >
            <el-button slot="reference" type="danger">删除信息</el-button>
          </el-popconfirm>
        </template> -->
       <el-button type="primary">特殊标记（未上线）</el-button>
      </el-table-column>
    </el-table>
  </el-col>
</template>

<script>
  import {
    // protocol_ZgrShopOstentation_Membership_list,
    // protocol_ZgrShopOstentationOrder_Membership_eidt,
    // protocol_ZgrShopOstentationOrder_Membership_add,
    // protocol_ZgrShopOstentationOrder_Membership_delete,
    protocol_get_game_version
  } from '@/assets/js/network/request'
  import {
    gUtilityTime
  } from '@/assets/js/utility/UtiltiyTime'

  import ComponentDatePicker from "@/components/ComponentDatePicker";
  import {
    gGameData
  } from '@/assets/js/data/GameData'
  import {
      gUtilityExcel
    } from "@/assets/js/utility/UtilityExcel";
  import {
    gAccount
  } from '@/assets/js/data/Account'
  export default {
    components: {
      ComponentDatePicker
    },
    data() {
      return {
        modify_div:'',
        tableData: [],
        shop_game:[],
        search: '',
        dialogFormVisible: false,
        dialogFormVisible_modify:false,
        btnChangeEnable:false,
        form: {
          member_id:"",
          member_name:"",
          phone:"",
          recharge_money:"",
          give_money:"",
          card_holder:"",
        },
        formLabelWidth: '120px',
        value1:'',
        err_data:'问题结论指引：\r\n游戏版本自检错误:先运行版本检测工具,再来本页面校验,如果仍旧显示错误,则需要更新游戏请联系区域经理获取正确游戏版本链接,更新后手动运行版本检测工具。\r\n游戏未安装: 需要更新游戏请联系区域经理获取正确游戏版本链接,更新后手动运行版本检测工具。\r\n游戏安装后未运行版本检测工具: 请手动运行版本检测工具。',
        loading_status:false,
      }
    },
    methods: {
      //按时间查询
      ostentation_time(){
        this.init_list(gUtilityTime.startTime(this.$refs.ComponentDatePicker.get_time_start())/1000,gUtilityTime.endTime(this.$refs.ComponentDatePicker.get_time_end())/1000)
      },
      //添加信息
      add_information(){
        this.dialogFormVisible = true;
        this.value1 =new Date;
        this.form.member_id ='';
        this.form.member_name ='';
        this.form.phone ='';
        this.form.recharge_money ='';
        this.form.give_money ='';
        this.form.card_holder ='';
        this.modify_div='';
      },
      // 删除信息
      delete_information(row){
        let _this=this;
        protocol_ZgrShopOstentationOrder_Membership_delete(row.id).then(res=>{
            _this.$message({
              message: '删除成功',
              type: 'success'
            });
           _this.init_list();
        })
      },
      game_name(id){
        return gGameData.getDataByID(id)
      },
      ret_YearMonthDate(time){
        return gUtilityTime.YearMonthDate(time,1)+gUtilityTime.YearMonthDate(time,2)+gUtilityTime.YearMonthDate(time,3)
      },
      ret_YearMonthDateHoursMin(time){
        return gUtilityTime.YearMonthDate(time,4)+gUtilityTime.YearMonthDate(time,5)
      },
      // 修改信息
      modify_information(row){
        this.dialogFormVisible_modify = true;
        this.value1 =row.time*1000;
        this.form.member_id =row.member_id;
        this.form.member_name =row.member_name;
        this.form.phone =row.phone;
        this.form.recharge_money =row.recharge_money;
        this.form.give_money =row.give_money;
        this.form.card_holder =row.card_holder;
        this.modify_div=row;
      },
      //修改提交
      startGame_modify(row){
        var _this = this;
        if(this.form.member_id==''){
          this.$message({
            message: '会员号不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.member_name==''){
          this.$message({
            message: '会员名不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.phone==''){
          this.$message({
            message: '手机号不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.recharge_money==''){
          this.$message({
            message: '充值金额不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.give_money==''){
          this.$message({
            message: '赠送金额不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.card_holder==''){
          this.$message({
            message: '办卡人不能为空',
            type: 'warning'
          });
          return
        }
        protocol_ZgrShopOstentationOrder_Membership_eidt(
        parseInt(new Date(this.value1).getTime()/1000),
        this.form.member_id,
        this.form.member_name,
        this.form.phone,
        this.form.recharge_money,
        this.form.give_money,
        this.form.card_holder,
        this.modify_div.id
        ).then(res=>{
          if(res.code==0){
            _this.$message({
              message: '修改成功',
              type: 'success'
            });
            _this.dialogFormVisible_modify=false;
            _this.init_list();
          }
        })
      },
      daochu(){
        let title=`序号,日期,会员号,会员名,电话,充值金额,赠送金额,办卡人\n`;
        let data=[];
        for(let i=0;i<this.tableData.length;i++){
          let obj=Object();
          obj.index=(i+1);
          obj.time_start=this.tableData[i].time_year+"-"+this.tableData[i].time_month+"-"+this.tableData[i].time_day;
          obj.member_id=this.tableData[i].member_id;
          obj.member_name=this.tableData[i].member_name;
          obj.phone=this.tableData[i].phone;
          obj.recharge_money=this.tableData[i].recharge_money;
          obj.give_money=this.tableData[i].give_money;
          obj.card_holder=this.tableData[i].card_holder;
          data.push(obj)
        }
        gUtilityExcel.download_excel("会员卡销售数据.xls",title,data)
      },
      //提交
      startGame() {
        var _this = this;
        if(this.form.member_id==''){
          this.$message({
            message: '会员号不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.member_name==''){
          this.$message({
            message: '会员名不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.phone==''){
          this.$message({
            message: '手机号不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.recharge_money==''){
          this.$message({
            message: '充值金额不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.give_money==''){
          this.$message({
            message: '赠送金额不能为空',
            type: 'warning'
          });
          return
        }
        if(this.form.card_holder==''){
          this.$message({
            message: '办卡人不能为空',
            type: 'warning'
          });
          return
        }
        protocol_ZgrShopOstentationOrder_Membership_add(
        parseInt(new Date(this.value1).getTime()/1000),
        this.form.member_id,
        this.form.member_name,
        this.form.phone,
        this.form.recharge_money,
        this.form.give_money,
        this.form.card_holder
        ).then(res=>{
          if(res.code==0){
            _this.$message({
              message: '添加成功',
              type: 'success'
            });
            _this.dialogFormVisible=false;
            _this.init_list();
          }
        })
      },
      //关闭弹窗
      cannelStartGame() {
        this.dialogFormVisible = false;
        this.dialogFormVisible_modify = false;
      },
      init_list(time_start,time_end){
        let _this=this;
        let date=new Date();
        if(time_start==undefined){
          time_start=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),1);
          time_end=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),2);
        }
        protocol_ZgrShopOstentation_Membership_list(time_start,time_end).then(res=>{
          _this.tableData=res.ret;
        })
      },
      get_vesion(){
        let _this=this;
        _this.loading_status=true;
        _this.tableData=[];
        protocol_get_game_version().then(res=>{

          _this.tableData=res.ret;
        })
        _this.loading_status=false;
      }

    },
    mounted() {
      this.DaySafter_list=gUtilityTime.DaySafter7();
      this.radio1=this.DaySafter_list[0];
      this.shop_game = gGameData.getAllDataShopData();
      this.get_vesion();
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/GameVersion.vue